module.exports = __webpack_public_path__ + "static/media/shield.e959afbe.svg";